import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonAttributesRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/attributes` — the address the embedded app's profile tab bar links
 * to. It forwards to the tab's own URL once the rollout flag is on, and renders the embedded app
 * in place while it is off.
 */
function JourneysPersonAttributesIndexRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonAttributesRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/')({
  component: JourneysPersonAttributesIndexRoute,
});
